import React from 'react';
import PremiumTravelSection from '../components/travel/PremiumTravelSection';

export default function TravelPage() {
  return <PremiumTravelSection />;
}
